import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import EditorPreferencesQuery, {
	type EditorPreferencesQuery$data,
	type EditorPreferencesQuery$variables,
} from './__generated__/EditorPreferencesQuery.graphql';

export const preloadEditorPreferenceQuery = () =>
	query<EditorPreferencesQuery$data, EditorPreferencesQuery$variables>({
		query: EditorPreferencesQuery,
	});
